const SELECTORS = {
  dropdown: '.topbar-dropdown',
  anchors: '.disclosure-list .disclosure-list__item a[href="SHOP_DOMAIN"] button',
  currentSelect: '.disclosure__toggle .disclosure__toggle-content',
  mobileDropdown: '.topbar__dropdown-mobile',
  mobileAnchors: '.mobile-menu__disclosure a[href="SHOP_DOMAIN"] button',
  mobileCurrentSelect: '.current-selection',
};

function getCurrentSelection(dropdown, anchors) {
  let textElement = null;

  if (window.location.href.replace(window.location.origin, '').slice(0, 3) === 'de') {
    textElement = dropdown.querySelector(anchors.replace('SHOP_DOMAIN', window.location.origin + '/de'));
  } else {
    textElement = dropdown.querySelector(anchors.replace('SHOP_DOMAIN', window.location.origin))
    || dropdown.querySelector(anchors.replace('SHOP_DOMAIN', window.location.origin + '/'));
  }

  return textElement;
}

const dropdowns = document.querySelectorAll(SELECTORS.dropdown);
dropdowns.forEach((dropdown) => {
  const currentSelect = dropdown.querySelector(SELECTORS.currentSelect);

  const textElement = getCurrentSelection(dropdown, SELECTORS.anchors);

  const text = textElement?.textContent.trim();

  if (currentSelect && text !== undefined && text !== '') {
    currentSelect.innerText = text;
  }
});

const mobileDropdowns = document.querySelectorAll(SELECTORS.mobileDropdown);
mobileDropdowns.forEach((dropdown) => {
  const currentSelect = dropdown.querySelector(SELECTORS.mobileCurrentSelect);

  const textElement = getCurrentSelection(dropdown, SELECTORS.mobileAnchors);

  const text = textElement?.textContent.trim();

  if (currentSelect && text !== undefined && text !== '') {
    currentSelect.innerText = text;
  }
});
